import React, { useContext, useEffect, useState, useRef } from "react";
import { AuthContext } from "../Auth";
import EditIcon from '@mui/icons-material/Edit';
import SendIcon from '@mui/icons-material/Send';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import PersonIcon from '@mui/icons-material/Person';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import InfoIcon from '@mui/icons-material/Info';
import SettingsIcon from '@mui/icons-material/Settings';
import BusinessIcon from '@mui/icons-material/Business';
import ContactEmergencyIcon from '@mui/icons-material/ContactEmergency';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { useNavigate } from "react-router-dom";
import { SetPageTitle } from "../SetPageTitle";
import { getAuth, sendEmailVerification } from "firebase/auth";
import { FireactContext } from "../Fireact";
import { Alert, Box, Button, Card, CardActions, CardHeader, Container, Paper, Typography, CircularProgress, Dialog, ListItemText, ListItemButton, List, Slide, AppBar, Toolbar, IconButton, Divider, Select, MenuItem, FormControl, InputLabel, Chip } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import Grid from '@mui/material/Grid2';
import TextField from '@mui/material/TextField';
import { httpsCallable } from "firebase/functions";
import { Stack } from "@mui/system";
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import LoadingButton from '@mui/lab/LoadingButton';
import SaveIcon from '@mui/icons-material/Save';
import { MuiTelInput, matchIsValidTel } from 'mui-tel-input';
import Link from '@mui/material/Link';
import CenterFocusWeakIcon from '@mui/icons-material/CenterFocusWeak';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

// https://firebase.google.com/docs/storage/web/start
import { getStorage, ref, uploadBytesResumable, getDownloadURL, deleteObject } from "firebase/storage";
import { collection, query, where, getDocs, getDoc, doc, setDoc, addDoc, deleteDoc, GeoPoint, serverTimestamp } from 'firebase/firestore';
import Footer from "../../../../template/Footer";
import {PageSection} from "../../../../template/TemplateElements";
import {APIProvider, Map, Marker, useMapsLibrary, useMap, createMarker} from '@vis.gl/react-google-maps';
import {QueryAddress, PlaceAutocomplete} from "../../../../components/google_maps/MapComponents";
import * as geofire from 'geofire-common';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const UserAccount = ({loader}) => {
    const { authInstance, firestoreInstance, functionsInstance } = useContext(AuthContext);
    const { config } = useContext(FireactContext);
    const navigate = useNavigate();
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(null);
    const [processing, setProcessing] = useState(false);
    const { authUser } = useContext(AuthContext);
    
    //console.log('authUser ', authUser);

    //Vancouver 49.2827291 -123.1207375
    const [position, setPosition] = useState({lat: 49.2827291, lng: -123.1207375});
    const setMarker = (lat, lng) => {
      setPosition({lat: lat, lng: lng});
    }

        const [myAddress, setMyAddress] = useState(null);
        const [addressEntered, setAddressEntered] = useState('');
        const currentMyAddress = useRef(null);
        const [clear, setClear] = useState(false);
        const [isDisabled, setIsDisabled] = useState(false); // Initially not disabled
        const [verificationComplete, setVerificationComplete] = useState(false); // Initially verified
        const [nurseVerifiedStatus, setNurseVerifiedStatus] = useState('');

        const [nurseForm, setNurseForm] = useState({
                fullName: "",
                email: "",
                phone: "",
                licenseNumber: "",
                licenseType: "",
                states: [],
                certifications: [],
        });
        const [submitting, setSubmitting] = useState(false);
        const [success, setSuccess] = useState(false);
        const [isFormDirty, setIsFormDirty] = useState(false);

        useEffect(() => {

    const getExistingUserServiceAccount = async () => {
        //get existing user service account
        const docRef = doc(firestoreInstance, "userServiceAccounts", authUser.user.uid);
        await getDoc(docRef).then(docSnap => {
            const data = docSnap.data();
            if (data?.name) {
                setName(data.name);
            }
            if (data?.email) {
                setEmail(data.email);
            }
            if (data?.phone) {
                setPhone(data.phone);
            }
            if (data?.emergencyContact) {
                setEmergencyContact(data.emergencyContact);
            }
            if (data?.license) {
                setLicense(data.license);
            }
        }).catch(err => {
            // ignore
        });
    }

    // If auth or firestore not ready yet, bail out so UI can render
    console.log('UserAccount effect start', { authUserPresent: !!authUser, authUid: authUser?.user?.uid, firestoreReady: !!firestoreInstance });
    if (!authUser || !authUser.user || !firestoreInstance) {
        console.log('UserAccount: auth or firestore not ready, setting loaded=true and exiting effect');
        setLoaded(true);
        return;
    }

    setLoaded(false);
    setError(null);

    // load places for this user
    const placesRef = collection(firestoreInstance, '/places');
    const placeQuery = query(placesRef, where('users', 'array-contains', authUser.user.uid));

    console.log('UserAccount: fetching places for uid', authUser.user.uid);
    getDocs(placeQuery).then((placeSnapshot) => {
        console.log('UserAccount: placeSnapshot size', placeSnapshot.size);
        placeSnapshot.forEach(record => {
            const address = record.data();
            console.log('UserAccount: found place', record.id, address);
            setPosition({lat: address.lat, lng: address.lng});
            setMyAddress({...address, ...{id:record.id}});
            currentMyAddress.current = {...address, ...{id:record.id}};
        });
        setLoaded(true);
    }).catch(error => {
        console.error('UserAccount: places fetch error', error);
        setLoaded(true);
        setError(error.message);
    });

    console.log('UserAccount: calling getExistingUserServiceAccount');
    getExistingUserServiceAccount();

    const getNurseVerifiedStatus = async () => {
        try {
            const docRef = doc(firestoreInstance, 'nurses', authUser.user.uid);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                const data = docSnap.data();
                setNurseVerifiedStatus(data?.verifiedStatus || '');
            } else {
                setNurseVerifiedStatus('');
            }
        } catch (err) {
            console.error('Error fetching nurse verifiedStatus', err);
            setNurseVerifiedStatus('');
        }
    };

    getNurseVerifiedStatus();

        const getIdentityVerificationStatus = async () => {
            // Get a reference to the didit_verifications document for this user.
            const docRef = doc(firestoreInstance, 'didit_verifications', authUser.user.uid);
        
            try {
            // Await the document snapshot.
            const documentSnap = await getDoc(docRef);
            if (documentSnap.exists()) {
                const data = documentSnap.data();
                // Check if a field named "status" exists and if it’s Approved.
                if (data?.status === "Approved") {
                    setVerificationComplete(true);
                    setIsDisabled(false);
                } else {
                    console.log("Status is not Approved:", data?.status);
                }
            } else {
                console.log("No data found for user service account.");
            }
            } catch (error) {
            console.error("Error fetching document:", error.message);
            }
        };

        getIdentityVerificationStatus();

    },[authInstance, config.saas.permissions, firestoreInstance, authUser?.user?.uid]);

    const addAddress = async () => {
        const placesRef = collection(firestoreInstance, '/places');
        const placeQuery = query(placesRef, where('address', '==', addressEntered));

        var addressAdded = false;

        //1. check if addressEntered is already in DB, if not add new address
        const querySnapshot = await getDocs(placeQuery);
        querySnapshot.forEach((record) => {
            const address = record.data();
            addressAdded = true;
            //2. add user to address
            const placeRef = doc(firestoreInstance, '/places', record.id);
            const currentUsers = address.users ? address.users : [];
            currentUsers.push(authUser.user.uid);
            setDoc(placeRef, { users: currentUsers }, { merge: true });
            setMyAddress({...address, ...{id:record.id}});
            console.log("existing data ", address);
        });

        if (!addressAdded) {
            // Compute the GeoHash for a lat/lng point
            const hash = geofire.geohashForLocation([position.lat, position.lng]);
            
            // Add the hash and the lat/lng to the document. We will use the hash
            // for queries and the lat/lng for distance comparisons.
            
            const docRef = addDoc(placesRef, {
                address: addressEntered,
                geohash: hash,
                lat: position.lat,
                lng: position.lng,
                position: new GeoPoint(position.lat, position.lng),
                users: [authUser.user.uid]
              }).then((docRef) => {
                getDoc(docRef).then(docSnap => {
                    const address = docSnap.data();
                    setMyAddress({...address, ...{id:docSnap.id}});
                    //console.log("place added with ID: ", docSnap.id);
                  }).catch(err => {
                    //
                  });
              });
        }
    }

    const updateAddress = async () => {
        //1. remove old address if there's any
        //console.log('logged in user', authUser.user.uid);
        //console.log('currentMyAddress.current', currentMyAddress.current);
        if (currentMyAddress.current.users.includes(authUser.user.uid)) {
            const users = currentMyAddress.current.users;
            const index = users.indexOf(authUser.user.uid);
            if (index > -1) { // only splice array when item is found
                users.splice(index, 1); 
            }
            //console.log('my address new users ', users);
            const docRef = doc(firestoreInstance, "places", currentMyAddress.current.id);
            setDoc(docRef, { users: users }, { merge: true });
        }
        //2. add new address
        addAddress();
        setAddressEntered('');
        setClear(true);
    }

    const [tabValue, setTabValue] = React.useState('1');

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const steps = [
        'Account Settings',
        'License Verification',
        'Identity Verification',
        'Service Area'
    ];
    // when adding treatments, only add uid and pid to services doc
    // createTreatmentService function will process the rest

    const [activeStep, setActiveStep] = React.useState(0); // read from DB
    const [loadingStep1, setLoadingStep1] = React.useState(false);
    const ref = React.useRef(null);
    useEffect(() => {
        // Scroll to top when step changes
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [activeStep]);

    useEffect(() => {
        if (activeStep === 1) {
            // Load existing nurse data when entering License Verification step
            const loadNurseData = async () => {
                try {
                    const docRef = doc(firestoreInstance, "nurses", authUser.user.uid);
                    const docSnap = await getDoc(docRef);
                    if (docSnap.exists()) {
                        const data = docSnap.data();
                        setNurseForm({
                            fullName: data.fullName || "",
                            email: data.email || "",
                            phone: data.phone || "",
                            licenseNumber: data.licenseNumber || "",
                            licenseType: data.licenseType || "",
                            states: data.states || [],
                            certifications: Array.isArray(data.certifications) ? data.certifications : [],
                        });
                        // Note: Not setting success here to avoid showing the submission message on load
                    }
                } catch (error) {
                    console.error("Error loading nurse data:", error);
                }
            };
            loadNurseData();
        }
    }, [activeStep, authUser.user.uid, firestoreInstance]);

    const [invalidPhoneNumber, setInvalidPhoneNumber] = React.useState(false);
    const [phone, setPhone] = React.useState('');
    const handlePhoneNumberChange = (newPhone) => {
        setPhone(newPhone);
    };

    const [email, setEmail] = useState(authUser.user.email);
    const [emailError, setEmailError] = useState(false);
    const handleEmailChange = e => {
        setEmail(e.target.value);
        if (!/^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$/.test(e.target.value)) {
          setEmailError(true);
        } else {
          setEmailError(false);
        }
    };

    const [name, setName] = useState(authUser.user.displayName);
    const [nameError, setNameError] = useState(false);
    const [nameHelperText, setNameHelperText] = useState('Service name to be used on Living Waters');
    const handleNameChange = e => {
        setName(e.target.value);
        if (e.target.value.length < 3) {
            setNameHelperText("Name must be at least 3 characters long");
            setNameError(true);
        } else if (e.target.value.length > 20) {
            setNameHelperText("Name must be less than 20 characters long");
            setNameError(true);
        } else if (!/^[a-zA-Z ]+$/.test(e.target.value)) {
            setNameHelperText("Name must contain only letters and spaces");
            setNameError(true);
        } else {
          setNameError(false);
          setNameHelperText("Service name to be used on Living Waters");
        }
    };

    const [emergencyContact, setEmergencyContact] = useState('');
    const handleEmergencyContactChange = e => {
        setEmergencyContact(e.target.value);
    };

    const saveServiceInfo = async () => {
        //console.log('save service info', phone);
        const isValidatePhonenumber = matchIsValidTel(phone);
        setInvalidPhoneNumber(!isValidatePhonenumber);
        //setInvalidPhoneNumber(true);
        if (isValidatePhonenumber && !emailError && !nameError) {

            const docRef = doc(firestoreInstance, "userServiceAccounts", authUser.user.uid);
            await setDoc(docRef, {
                name: name,
                email: email,
                phone: phone,
                emergencyContact: emergencyContact
            },{merge: true}).then(() => {
                setActiveStep(1);
            }).catch((error) => {
              //
            });
        }
        //console.log('service info', name, email, phone, emergencyContact);
    };

    const [license, setLicense] = useState('');
    const handleLicenseChange = e => {
        setLicense(e.target.value);
    };

    const saveLicenseInfo = async () => {
        const docRef = doc(firestoreInstance, "userServiceAccounts", authUser.user.uid);
        await setDoc(docRef, {
            license: license
        },{merge: true}).then(() => {
            setActiveStep(2);
        }).catch((error) => {
            //
        });
        //console.log('license info', license);
    };

    const handleNurseChange = (e) => {
        const { name, value } = e.target;
        setNurseForm((prev) => ({ ...prev, [name]: value }));
        setIsFormDirty(true);
    };

    const handleStateSelect = (e) => {
        const options = Array.from(e.target.selectedOptions).map((o) => o.value);
        setNurseForm((prev) => ({ ...prev, states: options }));
    };

    const handleNurseSubmit = async (e) => {
        e.preventDefault();
        setSubmitting(true);

        try {
            await setDoc(doc(firestoreInstance, "nurses", authUser.user.uid), {
                ...nurseForm,
                verifiedStatus: "pending",
                createdAt: serverTimestamp(),
            });

            setSuccess(true);
            setIsFormDirty(false);
        } catch (err) {
            console.error("Error submitting nurse onboarding form:", err);
        }

        setSubmitting(false);
    };

    const saveAddressInfo = () => {
        if (myAddress) {
            navigate('/dashboard');
        }
    }

    // State variables to store the verification session URL, loading state, and errors
    const [sessionUrl, setSessionUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const [errorVerification, setErrorVerification] = useState('');

    // Function that calls your backend to create a Didit verification session.
    async function createVerificationSession() {
        setLoading(true);
        setErrorVerification('');
        const createDiditSession = httpsCallable(functionsInstance, 'fireactjsSaas-createDiditSessionCallable');
        createDiditSession({ vendor_data: authUser.user.uid, callback: "https://dev.livingwaters.biz/diditcallback" }).then((res) => {
            //console.log('res ', res);
            setSessionUrl(res.data.url);
            setLoading(false);
        }).catch(error => {
            console.log('error ', error);
            setLoading(false);
            setErrorVerification(error);
        });
    }

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = (event) => {
        event.currentTarget.blur();
        setOpen(true);
        createVerificationSession();
        //setSessionUrl("/diditcallback");
    };

    const handleClose = () => {
        if (document.activeElement && document.activeElement.blur) {
            document.activeElement.blur();
        }
        setOpen(false);
    };

    useEffect(() => {
        // Listen for messages from the iframe
        const handleMessage = async (event) => {
            // Log event.data for debugging
            console.log('Verification event data:', event.data);

            // If the message is just the string 'diditVerificationComplete'
            if (event.data === 'diditVerificationComplete') {
                handleClose();
                setIsDisabled(false);
                // Refetch verification status from Firestore
                try {
                    const docRef = doc(firestoreInstance, 'didit_verifications', authUser.user.uid);
                    const documentSnap = await getDoc(docRef);
                    if (documentSnap.exists()) {
                        const data = documentSnap.data();
                        if (data?.status === 'Approved') {
                            setVerificationComplete(true);
                        } else {
                            setVerificationComplete(false);
                            setErrorVerification('Verification not approved. Please retry.');
                        }
                    } else {
                        setVerificationComplete(false);
                        setErrorVerification('No verification data found.');
                    }
                } catch (error) {
                    setVerificationComplete(false);
                    setErrorVerification('Error fetching verification status.');
                }
                return;
            }

            // If data is a string, try to parse it
            let data = event.data;
            if (typeof data === 'string') {
                try {
                    data = JSON.parse(data);
                } catch (e) {
                    // Not JSON, keep as string
                }
            }

            if (data && data.type === 'diditVerificationComplete') {
                handleClose();
                setIsDisabled(false);
                if (data.status === 'Approved') {
                    setVerificationComplete(true);
                } else {
                    setErrorVerification('Verification not approved. Please retry.');
                }
                //console.log('Received diditVerificationComplete, closing Dialog.');
            }
        };

        window.addEventListener('message', handleMessage);
        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);
    
    return (
        <>
        <div ref={ref}>
            {loaded?(
                <Container maxWidth={false} disableGutters>
                    <SetPageTitle title="Account" />
                    <Box sx={{ p: 2, width: '100%'}}>
                        <Typography component="div" variant="h6" py={1}>
                        {authUser.user !== null && (
                            <Stack direction="row" spacing={2} alignItems="center">
                                { (nurseVerifiedStatus === 'approved' || nurseVerifiedStatus === 'verified') ? (
                                    <Chip label="Verified" color="success" icon={<CheckCircleIcon />} />
                                ) : nurseVerifiedStatus === 'pending' ? (
                                    <Chip label="Pending verification" color="warning" icon={<InfoIcon />} />
                                ) : nurseVerifiedStatus === 'rejected' ? (
                                    <Chip label="Verification rejected" color="error" icon={<CloseIcon />} />
                                ) : verificationComplete ? (
                                    <Chip label="Identity verified" color="success" icon={<CheckCircleIcon />} />
                                ) : (
                                    <Chip label="Set up service account" />
                                )}

                                <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                                    { (nurseVerifiedStatus === 'approved' || nurseVerifiedStatus === 'verified') ? (
                                        'You can manage your service and schedule.'
                                    ) : nurseVerifiedStatus === 'pending' ? (
                                        'Verification is under review.'
                                    ) : nurseVerifiedStatus === 'rejected' ? (
                                        'Please review and resubmit your license information.'
                                    ) : verificationComplete ? (
                                        'Complete service area setup to finish onboarding.'
                                    ) : (
                                        'Start by filling out your service information.'
                                    ) }
                                </Typography>
                            </Stack>
                        )}
                        {authUser.user === null && <>Welcome to Living Waters</>}
                        </Typography>

                    </Box>
                    <PageSection sx={{height: '100%'}}>
                        <Box sx={{ width: '100%' }}>
                            <Stepper activeStep={activeStep} alternativeLabel>
                            {steps.map((label) => (
                                <Step key={label}>
                                <StepLabel>{label}</StepLabel>
                                </Step>
                            ))}
                            </Stepper>
                        </Box>
                        {activeStep == 0 && (
                        <Box sx={{ flexGrow: 1, p: 2, width: '100%', minHeight: '100vh'}} >
                            <Box sx={{ textAlign: 'center', mb: 4 }}>
                                <SettingsIcon sx={{ fontSize: 48, color: 'primary.dark', mb: 2 }} />
                                <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.dark' }}>
                                    Account Settings
                                </Typography>
                                <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: 600, mx: 'auto' }}>
                                    Set up your service information and emergency contact details.
                                </Typography>
                            </Box>
                            <Grid container spacing={3}>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Card sx={{ p: 3, height: '100%' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                                            <BusinessIcon sx={{ mr: 1, color: 'primary.dark' }} />
                                            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                                Service Information
                                            </Typography>
                                        </Box>
                                        <Stack spacing={3}>
                                            <TextField
                                                helperText={nameHelperText}
                                                id="name-helper-text-aligned"
                                                label="Service Name"
                                                required
                                                value={name}
                                                onChange={handleNameChange}
                                                error={nameError}
                                                fullWidth
                                            />
                                            <TextField
                                                helperText="Can be different to your user account email"
                                                id="email-helper-text-aligned"
                                                label="Service Email"
                                                required
                                                value={email}
                                                onChange={handleEmailChange}
                                                error={emailError}
                                                fullWidth
                                            />
                                            <MuiTelInput
                                                helperText="This phone number is only used for your service"
                                                id="phone-helper-text-aligned"
                                                label="Service Phone Number"
                                                required
                                                error={invalidPhoneNumber}
                                                value={phone} onChange={handlePhoneNumberChange}
                                                defaultCountry='US'
                                                fullWidth
                                            />
                                        </Stack>
                                    </Card>
                                </Grid>
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Card sx={{ p: 3, height: '100%' }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                                            <ContactEmergencyIcon sx={{ mr: 1, color: 'primary.dark' }} />
                                            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                                Emergency Contact
                                            </Typography>
                                        </Box>
                                        <Stack spacing={3}>
                                            <TextField
                                                helperText="Please enter your emergency contact information"
                                                id="emergency-contact-helper-text-aligned"
                                                label="Emergency Contact"
                                                value={emergencyContact}
                                                onChange={handleEmergencyContactChange}
                                                fullWidth
                                                multiline
                                                rows={3}
                                            />
                                        </Stack>
                                    </Card>
                                </Grid>
                            </Grid>
                            <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
                                <LoadingButton
                                    loading = {loadingStep1}
                                    loadingPosition="start"
                                    startIcon={<SaveIcon />}
                                    variant="contained"
                                    size="large"
                                    sx={{ px: 4 }}
                                    onClick={() => {
                                        saveServiceInfo();
                                    }}
                                >
                                    Save & Continue
                                </LoadingButton>
                            </Box>
                        </Box>
                        )}
                        {activeStep == 1 && (
                        <Box sx={{ flexGrow: 1, p: 2, width: '100%', minHeight: '100vh'}} >
                            <Grid container spacing={0}>
                                <Grid size={{ xs: 12, md: 12 }}>
                                    <PageSection>
                                        <Box sx={{ textAlign: 'center', mb: 4 }}>
                                            <VerifiedUserIcon sx={{ fontSize: 48, color: 'primary.dark', mb: 2 }} />
                                            <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.dark' }}>
                                                Nurse License Verification
                                            </Typography>
                                            <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: 600, mx: 'auto' }}>
                                                Please complete the form below to begin the verification process. All information will be kept confidential and used only for licensing verification.
                                            </Typography>
                                        </Box>

                                        {success && (
                                            <Alert severity="success" sx={{ mb: 3 }}>
                                                Your information has been submitted successfully. Our team will verify your license shortly and notify you via email.
                                            </Alert>
                                        )}

                                        <Box component="form" onSubmit={handleNurseSubmit} sx={{ mt: 2 }}>
                                            <Card sx={{ mb: 3, p: 2 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                                    <PersonIcon sx={{ mr: 1, color: 'primary.dark' }} />
                                                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                                        Personal Information
                                                    </Typography>
                                                </Box>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12} md={6}>
                                                        <TextField
                                                            label="Full Legal Name"
                                                            name="fullName"
                                                            value={nurseForm.fullName}
                                                            onChange={handleNurseChange}
                                                            required
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6}>
                                                        <TextField
                                                            label="Email Address"
                                                            name="email"
                                                            type="email"
                                                            value={nurseForm.email}
                                                            onChange={handleNurseChange}
                                                            required
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <TextField
                                                            label="Phone Number (optional)"
                                                            name="phone"
                                                            value={nurseForm.phone}
                                                            onChange={handleNurseChange}
                                                            fullWidth
                                                            helperText="Used for verification purposes only"
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Card>

                                            <Card sx={{ mb: 3, p: 2 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                                    <MedicalServicesIcon sx={{ mr: 1, color: 'primary.dark' }} />
                                                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                                        License Information
                                                    </Typography>
                                                </Box>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12} md={4}>
                                                        <TextField
                                                            label="License Number"
                                                            name="licenseNumber"
                                                            value={nurseForm.licenseNumber}
                                                            onChange={handleNurseChange}
                                                            required
                                                            fullWidth
                                                            helperText="Enter your full license number"
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <FormControl fullWidth required>
                                                            <InputLabel>License Type</InputLabel>
                                                            <Select
                                                                name="licenseType"
                                                                value={nurseForm.licenseType}
                                                                onChange={handleNurseChange}
                                                                label="License Type"
                                                            >
                                                                <MenuItem value="RN">Registered Nurse (RN)</MenuItem>
                                                                <MenuItem value="LPN">Licensed Practical Nurse (LPN/LVN)</MenuItem>
                                                                <MenuItem value="APRN">Advanced Practice RN (APRN)</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={12} md={4}>
                                                        <FormControl fullWidth required>
                                                            <InputLabel>State(s) of Licensure</InputLabel>
                                                            <Select
                                                                multiple
                                                                name="states"
                                                                value={nurseForm.states}
                                                                onChange={(e) => {
                                                                    const options = e.target.value;
                                                                    setNurseForm((prev) => ({ ...prev, states: options }));
                                                                    setIsFormDirty(true);
                                                                }}
                                                                label="State(s) of Licensure"
                                                                renderValue={(selected) => selected.join(', ')}
                                                            >
                                                                {["AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"].map((state) => (
                                                                    <MenuItem key={state} value={state}>{state}</MenuItem>
                                                                ))}
                                                            </Select>
                                                            <Typography variant="caption" sx={{ mt: 1, color: 'text.secondary' }}>
                                                                Select all states where you are licensed
                                                            </Typography>
                                                        </FormControl>
                                                    </Grid>
                                                </Grid>
                                            </Card>

                                            <Card sx={{ mb: 3, p: 2 }}>
                                                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                                    <InfoIcon sx={{ mr: 1, color: 'primary.dark' }} />
                                                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                                        Additional Information
                                                    </Typography>
                                                </Box>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12}>
                                                        <TextField
                                                            label="Certifications (optional)"
                                                            name="certifications"
                                                            placeholder="e.g., BLS, ACLS, IV Therapy"
                                                            value={nurseForm.certifications.join(", ")}
                                                            onChange={(e) => {
                                                                setNurseForm((prev) => ({
                                                                    ...prev,
                                                                    certifications: e.target.value.split(",").map((c) => c.trim()),
                                                                }));
                                                                setIsFormDirty(true);
                                                            }}
                                                            fullWidth
                                                            multiline
                                                            rows={3}
                                                            helperText="List your certifications separated by commas"
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Card>

                                            <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
                                                <LoadingButton
                                                    type="submit"
                                                    loading={submitting}
                                                    loadingPosition="start"
                                                    startIcon={<SaveIcon />}
                                                    variant="contained"
                                                    size="large"
                                                    sx={{ px: 4 }}
                                                    disabled={!isFormDirty}
                                                >
                                                    {submitting ? "Submitting..." : "Submit for Verification"}
                                                </LoadingButton>
                                            </Box>
                                        </Box>
                                    </PageSection>
                                </Grid>
                            </Grid>
                            <Typography variant="body1" align="center" sx={{p:2}} gutterBottom py={1}>
                            <Stack spacing={2} direction="row" justifyContent="center" alignItems="center">
                                <Button variant="outlined" onClick={() => {
                                        setActiveStep(0);
                                    }}>Previous</Button>
                                <LoadingButton
                                    loading = {loadingStep1}
                                    loadingPosition="start"
                                    startIcon={<SaveIcon />}
                                    variant="outlined"
                                    onClick={() => {
                                        saveLicenseInfo();
                                    }}
                                >
                                    Continue
                                </LoadingButton>
                            </Stack>
                            </Typography>
                        </Box>
                        )}
                        {activeStep == 2 && (
                        <Box sx={{ flexGrow: 1, p: 2, width: '100%', minHeight: '100vh'}} >
                            <Box sx={{ textAlign: 'center', mb: 4 }}>
                                <VerifiedUserIcon sx={{ fontSize: 48, color: 'primary.dark', mb: 2 }} />
                                <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.dark' }}>
                                    Identity Verification
                                </Typography>
                                <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: 600, mx: 'auto' }}>
                                    Please verify your identity to complete the onboarding process. This step is required for security purposes.
                                </Typography>
                            </Box>
                            <Grid container spacing={3} justifyContent="center">
                                <Grid size={{ xs: 12, md: 8 }}>
                                    <Card sx={{ p: 4, textAlign: 'center' }}>
                                        {verificationComplete ? (
                                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                <CheckCircleOutlineIcon sx={{ fontSize: 64, color: 'success.main', mb: 2 }} />
                                                <Typography variant="h5" sx={{ fontWeight: 'bold', color: 'success.main', mb: 1 }}>
                                                    Identity Verification Completed
                                                </Typography>
                                                <Typography variant="body1" color="text.secondary">
                                                    Your identity has been successfully verified. You can now proceed to the next step.
                                                </Typography>
                                            </Box>
                                        ) : (
                                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                                {errorVerification && (
                                                    <Alert severity="error" sx={{ mb: 3, width: '100%' }}>
                                                        {errorVerification}
                                                    </Alert>
                                                )}
                                                <VerifiedUserIcon sx={{ fontSize: 64, color: 'primary.dark', mb: 3 }} />
                                                <Typography variant="h6" gutterBottom sx={{ fontWeight: 'medium' }}>
                                                    Start Identity Verification
                                                </Typography>
                                                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
                                                    Click the button below to begin the secure identity verification process.
                                                </Typography>
                                                <LoadingButton
                                                    loading={loading}
                                                    loadingPosition="start"
                                                    startIcon={<CenterFocusWeakIcon />}
                                                    variant="contained"
                                                    onClick={handleClickOpen}
                                                    size="large"
                                                    sx={{ px: 4 }}
                                                >
                                                    Start Verification
                                                </LoadingButton>
                                            </Box>
                                        )}
                                    </Card>
                                </Grid>
                            </Grid>
                            <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
                                <Stack spacing={2} direction="row">
                                    <Button variant="outlined" onClick={() => { setActiveStep(1); }}>
                                        Previous
                                    </Button>
                                    <LoadingButton
                                        loading={loadingStep1}
                                        loadingPosition="start"
                                        startIcon={<SaveIcon />}
                                        variant="contained"
                                        onClick={() => { setActiveStep(3); }}
                                        disabled={!verificationComplete}
                                        sx={{ px: 4 }}
                                    >
                                        Continue
                                    </LoadingButton>
                                </Stack>
                            </Box>
                        </Box>
                        )}
                        {activeStep == 3 && (
                        <Box sx={{ flexGrow: 1, p: 2, width: '100%', minHeight: '100vh'}} >
                            <Box sx={{ textAlign: 'center', mb: 4 }}>
                                <LocationOnIcon sx={{ fontSize: 48, color: 'primary.dark', mb: 2 }} />
                                <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.dark' }}>
                                    Service Area Setup
                                </Typography>
                                <Typography variant="body1" sx={{ color: 'text.secondary', maxWidth: 600, mx: 'auto' }}>
                                    Set up your service location and area. This helps clients find your services in their area.
                                </Typography>
                            </Box>
                            <APIProvider apiKey={'AIzaSyBDB3_zlIS4f6qxog7HrvJCJ31rnQnBxxk'}>
                                <Grid container spacing={3}>
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Card sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                                                <LocationOnIcon sx={{ mr: 1, color: 'primary.dark' }} />
                                                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                                    Address Management
                                                </Typography>
                                            </Box>
                                            <Box sx={{ flexGrow: 1 }}>
                                                {myAddress ? (
                                                    <>
                                                        <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'medium' }}>
                                                            Current Address
                                                        </Typography>
                                                        <Typography variant="body1" gutterBottom sx={{ mb: 2 }}>
                                                            {addressEntered ? (
                                                                <Box>
                                                                    <Typography variant="body2" sx={{ fontStyle: 'italic', mb: 2 }}>
                                                                        Preview: {addressEntered}
                                                                    </Typography>
                                                                    <Stack direction="row" spacing={2}>
                                                                        <Button onClick={updateAddress} variant="contained" size="small">Confirm Change</Button>
                                                                        <Button onClick={() => {setAddressEntered('')}} variant="outlined" size="small">Cancel</Button>
                                                                    </Stack>
                                                                </Box>
                                                            ) : (
                                                                <Box>
                                                                    <Typography variant="body1" sx={{ mb: 1 }}>{myAddress.address}</Typography>
                                                                    <Typography variant="caption" color="text.secondary">
                                                                        Enter a new location below to change your address
                                                                    </Typography>
                                                                </Box>
                                                            )}
                                                        </Typography>
                                                    </>
                                                ) : (
                                                    <>
                                                        <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'medium' }}>
                                                            Set Your Service Address
                                                        </Typography>
                                                        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                                            {addressEntered ? (
                                                                <Box>
                                                                    <Typography variant="body2" sx={{ fontStyle: 'italic', mb: 2 }}>
                                                                        Preview: {addressEntered}
                                                                    </Typography>
                                                                    <Button onClick={addAddress} variant="contained" size="small">Add Address</Button>
                                                                </Box>
                                                            ) : (
                                                                <>You haven't entered an address for your service yet. Please enter your address below.</>
                                                            )}
                                                        </Typography>
                                                    </>
                                                )}
                                            </Box>
                                            <Box sx={{ mt: 3 }}>
                                                <PlaceAutocomplete 
                                                    setMarker={setMarker} 
                                                    showCircle={false} 
                                                    setAddressEntered={setAddressEntered} 
                                                    label={`Enter Service Address`} 
                                                    clear={clear} 
                                                    setClear={setClear}
                                                />
                                            </Box>
                                        </Card>
                                    </Grid>
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Card sx={{ p: 3, height: '100%', display: 'flex', flexDirection: 'column' }}>
                                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                                                <LocationOnIcon sx={{ mr: 1, color: 'primary.dark' }} />
                                                <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                                    Location Preview
                                                </Typography>
                                            </Box>
                                            <Box sx={{ flexGrow: 1, minHeight: '400px', borderRadius: 1, overflow: 'hidden' }}>
                                                <Map center={position} zoom={10} disableDefaultUI={true} scrollwheel={false} gestureHandling={'none'} keyboardShortcuts={false}>
                                                    <Marker position={position} />
                                                </Map>
                                            </Box>
                                        </Card>
                                    </Grid>
                                </Grid>
                            </APIProvider>
                            <Box sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
                                <Stack spacing={2} direction="row">
                                    <Button variant="outlined" onClick={() => { setActiveStep(2); }}>
                                        Previous
                                    </Button>
                                    <Button
                                        variant="contained"
                                        onClick={() => { navigate('/agenda'); }}
                                        sx={{ px: 4 }}
                                    >
                                        Complete
                                    </Button>
                                </Stack>
                            </Box>
                        </Box>
                        )}
                        
                    </PageSection>
                    <Footer />
                </Container>
            ) : (
                <>{loader}</>
            )}
        </div>
        <Dialog
            fullScreen
            open={open}
            slots={{
            transition: Transition,
            }}
            onClose={handleClose}
        >
            <AppBar sx={{ position: 'fixed' }}>
            <Toolbar>
                <CenterFocusWeakIcon />
                <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div" py={1}>
                Identity Verification
                </Typography>
                <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
                >
                <CloseIcon />
                </IconButton>
            </Toolbar>
            </AppBar>
            {sessionUrl ? (
                <Box
                    component="iframe"
                    src={sessionUrl}
                    allow="camera; autoplay"
                    title="identity verification session"
                    sx={{
                        width: '100%',
                        minHeight: '100vh',
                        border: 0,       // Remove default border
                    }}
                    allowFullScreen
                    />
            ) : (
                <Box
                    sx={{
                        display: 'flex',             // Make the Box a flex container
                        flexDirection: 'column',       // Stack children vertically (optional; remove for horizontal layout)
                        justifyContent: 'center',      // Center vertically
                        alignItems: 'center',          // Center horizontally
                        minHeight: '50vh',            // Take full viewport height (adjust as needed)
                        textAlign: 'center',           // Center text inside each Typography as well (optional)
                    }}
                >
                    <CircularProgress size={24}/>
                    <Typography sx={{pt:2}} py={1}>
                        Loading verification session. 
                    </Typography>
                    <Typography py={1}>
                        This may take a few minutes...
                    </Typography>
                </Box>
            )}
        </Dialog>
        </>
    )
}